import { local } from 'wix-storage';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

let formFactor = wixWindow.formFactor; // "Mobile"
let items

$w.onReady(function () {

});

export function repeaterSteps_itemReady($item, itemData, index) {
	// console.log($item("#buttonLink").html)

	if (formFactor === "Mobile") {

		if (itemData.ctaMobileLink === "http://www.empty.empty") {
			$item("#buttonButtonLink").hide()
		} else {
			$item("#buttonButtonLink").show()
			$item("#buttonButtonLink").link = itemData.ctaMobileLink
			// $item("#buttonButtonLink").target = "_blank";
		}

		$item("#buttonLink").text = itemData.ctaMobile

		// $item("#buttonLink").html = `<p class="p1" style="font-size:18px; line-height:1.6em"><span style="font-size:15px"><span style="color:#000000"><span style="text-decoration:none">${itemData.ctaMobile}</span></span></span></p>`

		let richText = `<p class="p3" style="font-size:14px; line-height:1.6em"><span style="font-size:14px"><span style="color:#116DFF">${itemData.ctaMobile}</span></span></span></p>` //<span style="text-decoration:underline">

		let replaceLineHightP = richText.replace(/<p>/g, `<p class="p1" style="line-height:1.6; color: black;  font-size: 14px">`);
		let replaceLineHightU = replaceLineHightP.replace(/<u>/g, `<u class="p1" style="line-height:1.6; color: #116DFF; font-weight: bold; font-size: 14px">`);
		let replaceLineHightA = replaceLineHightU.replace(/<a>/g, `<a class="p1" style="line-height:1.6; color: #116DFF; font-weight: bold; font-size: 14px">`);
		let replaceLineHightStrong = replaceLineHightA.replace(/<strong>/g, `<strong class="p1" style="line-height:1.6; color: #000000; font-weight: bold; font-size: 14px">`);

		$item("#buttonLink").html = replaceLineHightStrong

	} else {

		if (itemData.ctaLInk === "http://www.empty.empty") {
			$item("#buttonButtonLink").hide()

		} else {
			$item("#buttonButtonLink").show()
			$item("#buttonButtonLink").link = itemData.ctaLInk
			// $item("#buttonButtonLink").target = "_blank";

		}

		$item("#buttonLink").text = itemData.cta
		// $item("#buttonLink").html = `<p class="p1" style="font-size:18px; line-height:1.6em"><span style="font-size:15px"><span style="color:#4a8dfb"><span style="text-decoration:underline">${itemData.cta}</span></span></span></p>`

		let richText = `<p class="p1" style="font-size:18px; line-height:1.6em"><span style="font-size:18px"><span style="color:#116DFF"><span style="text-decoration:underline">${itemData.cta}</span></span></span></p>` //

		let replaceLineHightP = richText.replace(/<p>/g, `<p class="p3" style="line-height:1.6; color: black;  font-size: 18px">`);
		let replaceLineHightU = replaceLineHightP.replace(/<u>/g, `<u class="p2" style="line-height:1.6; color: #116DFF; font-weight: bold; font-size: 18px">`);
		let replaceLineHightA = replaceLineHightU.replace(/<a>/g, `<a class="p2" style="line-height:1.6; color: #116DFF; font-weight: bold; font-size: 18px">`);
		let replaceLineHightStrong = replaceLineHightA.replace(/<strong>/g, `<strong class="p2" style="line-height:1.6; color: #116DFF; font-weight: bold; font-size: 18px">`);

		$item("#buttonLink").html = replaceLineHightStrong
	}

	$w("#datasetSteps").onReady(() => {
		console.log("descriptionMobileRich")
		console.log(itemData.descriptionMobileRich)

		let count = $w("#datasetSteps").getTotalCount();

		if (formFactor === "Mobile") {

			let richText = itemData.descriptionMobileRich

			let replaceLineHightP = richText.replace(/<p>/g, `<p class="p1" style="line-height:1.6; color: black;  font-size: 14px">`);
			let replaceLineHightU = replaceLineHightP.replace(/<u>/g, `<u class="p1" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 14px">`);
			let replaceLineHightA = replaceLineHightU.replace(/<a>/g, `<a class="p1" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 14px">`);
			let replaceLineHightStrong = replaceLineHightA.replace(/<strong>/g, `<strong class="p1" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 14px">`);

			$item("#textRich").html = replaceLineHightStrong

		} else {

			// let richText = $item("#textRich").html
			let richText = itemData.description

			let replaceLineHightP = richText.replace(/<p>/g, `<p class="p3" style="line-height:1.6; color: black;  font-size: 18px">`);
			let replaceLineHightU = replaceLineHightP.replace(/<u>/g, `<u class="p2" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 18px">`);
			let replaceLineHightA = replaceLineHightU.replace(/<a>/g, `<a class="p2" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 18px">`);
			let replaceLineHightStrong = replaceLineHightA.replace(/<strong>/g, `<strong class="p2" style="line-height:1.6; color: #2574fc; font-weight: bold; font-size: 18px">`);

			$item("#textRich").html = replaceLineHightStrong
		}

		///

		for (var x = 0; x < count; x++) {
			let value = local.getItem(itemData._id);

			if (value === itemData._id) {
				$item("#checkbox").checked = true

				$item("#headerText1").html = `<h2 style="font-size:12px"><span style="font-size:20px"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-weight:normal"><span style="font-style:normal"><span><span style="color:rgb(32, 48, 60)"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-size:20px"><span style="letter-spacing:0em"><span style="color:#b4b4b4">${itemData.title}</span></span></span></span></span></span></span></span></span></span></h2>`

			}

		}

	});

	$item("#checkbox").onChange((event) => {
		if ($item("#checkbox").checked === false) {
			local.removeItem(itemData._id);

		} else {
			local.setItem(itemData._id, itemData._id);

		}

	});

	let checkboxClick

	$item("#checkbox").onClick(() => {
		savedIndexCollapsed = itemData.sort

		if ($item("#checkbox").checked) {
			$item("#headerText1").html = `<h2 style="font-size:12px"><span style="font-size:20px"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-weight:normal"><span style="font-style:normal"><span><span style="color:rgb(32, 48, 60)"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-size:20px"><span style="letter-spacing:0em"><span style="color:#b4b4b4">${itemData.title}</span></span></span></span></span></span></span></span></span></span></h2>`

		} else {
			$item("#headerText1").html = `<h2 style="font-size:12px"><span style="font-size:20px"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-weight:normal"><span style="font-style:normal"><span><span style="color:rgb(32, 48, 60)"><span style="font-family:wfont_fee50a_efceb94cb9574526a2d64c4f7b939a57,wf_efceb94cb9574526a2d64c4f7,orig_wix_madefor_text_bold"><span style="font-size:20px"><span style="letter-spacing:0em"><span style="color:#000000">${itemData.title}</span></span></span></span></span></span></span></span></span></span></h2>`

		}

		$w("#repeaterSteps").forEachItem(($subitem, indexSave) => {
			// console.log(indexSave)
			let itemTitle = items[indexSave.sort - 1].title

			if (indexSave.sort !== savedIndexCollapsed) {

				// $subitem("#headerText1").html = `<h2 style="font-size:12px"><span style="font-size:20px"><span style="font-family:wfont_375882_f4850dce3d884644a1bceb2ee38c5c6b,wf_f4850dce3d884644a1bceb2ee,orig_helvetica_neue_w_01_65_medium"><span style="font-weight:normal"><span style="font-style:normal"><span><span style="color:rgb(32, 48, 60)"><span style="font-family:wfont_375882_f4850dce3d884644a1bceb2ee38c5c6b,wf_f4850dce3d884644a1bceb2ee,orig_helvetica_neue_w_01_65_medium"><span style="font-size:20px"><span style="letter-spacing:0em"><span style="color:#000000">${itemTitle}</span></span></span></span></span></span></span></span></span></span></h2>`

			}

		});

	});

	let savedIndexCollapsed

	$item("#headerBox1").onClick((event) => {
		savedIndexCollapsed = itemData.sort
		// console.log(savedIndexCollapsed)
		// console.log(indexSave.sort)
		$w("#repeaterSteps").forEachItem(($subitem, indexSave) => {

			if (indexSave.sort !== savedIndexCollapsed) {

				$subitem("#foldText").collapse();
				$subitem("#arrowRight").show();
				$subitem("#arrowDown").hide();
			}

		});

		if ($item("#foldText").collapsed) {

			$item("#foldText").expand();
			$item("#arrowRight").hide();
			$item("#arrowDown").show();

		} else {

			$item("#foldText").collapse();
			$item("#arrowRight").show();
			$item("#arrowDown").hide();

		}

	});

}

export function datasetSteps_ready() {
	let count = $w("#datasetSteps").getTotalCount(); // 23

	$w("#datasetSteps").getItems(0, count)
		.then((result) => {
			items = result.items;
			// console.log(items[0].title)
		})
		.catch((err) => {
			let errMsg = err.message;
			let errCode = err.code;
		});
}